import React from "react";
import { Link } from "react-router-dom";
import { pageLink } from "@/lib/landerDomain";
import { CheckCircle, Warning } from "@phosphor-icons/react";
import { SendTestLeadButton } from "@/components/SendTestLeadButton";
import { funnelTitle } from "@/lib/funnelOptions";
import { SetupInstructionsButton } from "@/components/delivery/SetupInstructionsButton";

const PageRow = ({ p }) => (
  <li className="flex items-start gap-2 text-sm" data-testid={`golive-page-${p.funnel}`}>
    {p.status === "published" ? <CheckCircle size={16} weight="bold" className="text-emerald-700 mt-0.5 shrink-0" /> : <Warning size={16} weight="bold" className="text-amber-700 mt-0.5 shrink-0" />}
    <span>
      <a href={pageLink(`/lp/${p.slug}${p.status === "published" ? "" : "?preview=1"}`, p.status === "published")} target="_blank" rel="noreferrer" className="underline font-bold">{funnelTitle(p.funnel)}</a>
      <span className="text-zinc-600"> — {p.status === "published" ? "published" : `saved as a draft: ${p.problem}`}</span>
    </span>
  </li>
);

export const GoLiveResult = ({ r, states }) => (
  <div className="border-2 border-black bg-emerald-50 p-5 sm:p-6 space-y-4" data-testid="golive-result">
    <div className="flex items-center gap-2 font-chivo font-black uppercase tracking-tight text-lg">
      <CheckCircle size={22} weight="bold" className="text-emerald-700" /> {r.client.name} is live
    </div>
    <ul className="text-sm space-y-1 text-zinc-800">
      <li>Leads go to: <b>{r.destination.name}</b> ({r.destination.type})</li>
      <li>Login invite: <b data-testid="golive-invite">{r.invite?.status === "invited" ? "sent" : r.invite?.status || "not sent"}</b></li>
      <li>Testimonials added: <b>{r.testimonials}</b> · Logo: <b>{r.logo ? "added" : "none"}</b></li>
    </ul>
    <div>
      <div className="label-mono mb-1">Their own branded pages</div>
      <ul className="space-y-1">{r.own_pages.map((p) => <PageRow key={p.id} p={p} />)}</ul>
      <p className="text-[11px] text-zinc-600 mt-2">Media buyers and affiliates set to All pages get these now. Give them to anyone else on Traffic Access.</p>
    </div>
    <div className="flex flex-wrap items-center gap-3">
      <SendTestLeadButton url="/admin/global-funnels/test-lead" body={{ buyer_page_id: r.profile.id }} showLeadLink
                          funnels={(r.profile.links || []).map((l) => l.funnel)} states={states} testId="golive-test-lead"
                          confirmText={`This sends one lead marked TEST into ${r.client.name}'s intake system. Continue?`} />
      {r.destination?.id && (
        <SetupInstructionsButton destId={r.destination.id} testId="golive-setup-instructions"
                                 className="border-2 border-black px-3 py-2 text-[11px] uppercase tracking-widest bg-white hover:bg-zinc-100 inline-flex items-center gap-1" />
      )}
      <Link to={`/clients/${r.client.id}/manage`} className="border-2 border-black px-3 py-2 text-[11px] uppercase tracking-widest bg-white hover:bg-zinc-100" data-testid="golive-manage">Open Manage Buyer</Link>
      <Link to="/admin/traffic-access" className="border-2 border-black px-3 py-2 text-[11px] uppercase tracking-widest bg-white hover:bg-zinc-100" data-testid="golive-traffic">Traffic Access</Link>
    </div>
  </div>
);
